import { Controller } from "@hotwired/stimulus"
import { debounce, deleteStream, patchJson, patchStream, postStream, sessionIdFor, syncRiskCard } from "./sweeper_shared"

export default class extends Controller {
  updateRisk(event) {
    this.updateFixedRisk(event)
    this.updateCustomRisk(event)
  }

  updateText(event) {
    this.updateFixedVorm(event)
    this.updateCustomName(event)
    this.updateCustomVorm(event)
  }

  toggleRow(event) {
    this.add(event)
    this.remove(event)
  }

  updateFixedRisk(event) {
    const field = event.target.closest("[data-fm]")
    if (!field) return

    syncRiskCard(field.closest(".fm"), field.value)
    this.saveFixed(field.dataset.fm, { risk: field.value })
  }

  updateFixedVorm(event) {
    const field = event.target.closest("[data-fm-vorm]")
    if (!field) return

    debounce(this, `fixed:${field.dataset.fmVorm}:vorm`, () => {
      const card = field.closest("[data-fm-card]")
      const risk = card?.querySelector("[data-fm]:checked")?.value || ""
      this.saveFixedText(field.dataset.fmVorm, { risk, vorm: field.value })
    })
  }

  updateCustomName(event) {
    const field = event.target.closest('[data-ssfm="name"]')
    if (field) this.updateCustom(field, "name")
  }

  updateCustomRisk(event) {
    const field = event.target.closest("[data-ssfm-risk]")
    if (!field) return

    syncRiskCard(field.closest(".fm"), field.value)
    this.saveCustom(field.dataset.ssfmRisk, { risk: field.value })
  }

  updateCustomVorm(event) {
    const field = event.target.closest("[data-ssfm-vorm]")
    if (field) this.updateCustom(field, "vorm")
  }

  add(event) {
    if (event && !event.target.closest('[data-editor-action="add-fm"]')) return
    const sessionId = this.sessionId
    if (!sessionId) return

    postStream(`/api/v1/sessions/${encodeURIComponent(sessionId)}/session_specific_fm`, {
      name: "",
      risk: "",
      vorm: ""
    })
  }

  remove(event) {
    const button = event.target.closest("[data-ssfm-del]")
    if (!button || !this.sessionId) return

    deleteStream(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/session_specific_fm/${button.dataset.ssfmDel}`)
  }

  updateCustom(field, key) {
    const index = field.dataset.idx || field.dataset.ssfmVorm
    if (index == null) return

    debounce(this, `custom:${index}:${key}`, () => {
      this.saveCustomText(index, { [key]: field.value })
    })
  }

  saveFixed(fieldId, attrs) {
    if (!this.sessionId) return

    // Risk changes affect Block 3's risk summary, so keep those on Turbo Streams.
    patchStream(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/failure_mode`, {
      fm_id: fieldId,
      risk: attrs.risk,
      vorm: attrs.vorm
    })
  }

  saveCustom(index, attrs) {
    if (!this.sessionId) return

    // Risk changes affect Block 3's risk summary, so keep those on Turbo Streams.
    patchStream(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/session_specific_fm/${index}`, attrs)
  }

  saveFixedText(fieldId, attrs) {
    if (!this.sessionId) return

    patchJson(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/failure_mode`, {
      fm_id: fieldId,
      risk: attrs.risk,
      vorm: attrs.vorm
    })
  }

  saveCustomText(index, attrs) {
    if (!this.sessionId) return

    const request = patchJson(`/api/v1/sessions/${encodeURIComponent(this.sessionId)}/session_specific_fm/${index}`, attrs)
    if (Object.prototype.hasOwnProperty.call(attrs, "name")) {
      request.then(session => this.syncCustomRiskName(index, session))
    }
  }

  syncCustomRiskName(index, session) {
    const pill = document.querySelector(`#editor-countermeasures [data-risk-id="ss_${index}"]`)
    if (!pill) return

    const failureMode = session?.sessionSpecificFMs?.[parseInt(index, 10)]
    if (!failureMode || !["mid", "high"].includes(failureMode.risk)) {
      pill.remove()
      return
    }

    pill.classList.remove("mid", "high")
    pill.classList.add(failureMode.risk)
    pill.textContent = failureMode.name || ""
  }

  get sessionId() {
    return sessionIdFor(this.element)
  }
}
